








import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import SpecOutContactStatusEnum from '@/models/SpecOuts/SpecOutContactStatus';


@Component({
  name: 'SpecOutContactStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: SpecOutContactStatusEnum;

	get pending() {
		return this.status === SpecOutContactStatusEnum.Pending;
	}

	get skipped() {
		return this.status === SpecOutContactStatusEnum.Skipped;
	}

	get processing() {
		return this.status === SpecOutContactStatusEnum.Processing;
	}
}
